import './App.css';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import LandingPage from './pages/landing_page';
import WebsiteBuilderLanding from './pages/WebsiteBuilderLanding';
import Login from './pages/Login';
import ContactUs from './pages/ContactUs';
import HomePage from './pages/HomePage';
import Register from './components/Register';
import PrivateRoute from './utils/PrivateRoute';
import { AuthProvider } from './context/AuthContext';
import Base from './components/Base'
import TermsAndServices from './components/TermsNcondn';
import ReturnPolicy from './components/ReturnPolicy';
import PaymentShipping from './components/PaymentShipping';
import PrivacyPolicy from './components/PrivacyPolicy';
import Faqs from './components/Faqs';
import Uploadproduct from './pages/Uploadproduct';
import Profile from './components/Profile';
import ManageAddress from './components/ManageAddress';
import  Contact  from './components/Contact';
import AboutMe from './components/AboutMe';
import Orders from './components/Orders';
import Proposals from './components/Proposals';
import EditProduct from './components/EditProduct';
import ForgotPassword from './components/ForgotPassword';
import TemplateSelector from './components/Subscription';
import Templates from './pages/Templates';
import TemplateThemes from './pages/TemplateThemes';
import TestPage from './pages/TestPage';
import AdminDashBoard from './components/AdminDashBoard';
import DesignerOnboarding from './components/DesignerOnboarding';
import AdminDesignerDashboard from './components/AdminDesignerDashboard';
import DesignerKYC from './components/DesignerKYC';
import DesignerProfile from './components/DesignerProfile';

// New Admin Dashboard
import AdminDashboard from './components/admin/AdminDashboard';
import AdminRoute from './components/admin/AdminRoute';


import Template1 from './components/Templates/Template1';
import Template2 from './components/Templates/Template2';
import Template3 from './components/Templates/Template3';
import Template4 from './components/Templates/Template4';
import Template5 from './components/Templates/Template5';
import Template6 from './components/Templates/Template6';
import Template7 from './components/Templates/Template7';
import Template8 from './components/Templates/Template8';
import Template9 from './components/Templates/Template9';
import Template10 from './components/Templates/Template10';
import Template11 from './components/Templates/Template11';
import Template12 from './components/Templates/Template12';
import Template13 from './components/Templates/Template13';
import Template14 from './components/Templates/Template14';
import Template15 from './components/Templates/Template15';
import Template16 from './components/Templates/Template16';
import Template17 from './components/Templates/Template17';
import Template18 from './components/Templates/Template18';
import Template19 from './components/Templates/Template19';
import Template20 from './components/Templates/Template20';


function App() {
  return (
    <Router>
      <AuthProvider>
        <Routes>
          <Route path="/" element={<WebsiteBuilderLanding />} />
          <Route path="/old-landing" element={<LandingPage />} />
          <Route path="/contactus" element={<ContactUs />} />
          <Route path="/login" element={<Login />} />
          <Route path="/termsNconditions" element={<TermsAndServices/>} />
          <Route path="/payShip" element={<PaymentShipping/>} />
          <Route path="/rtnPolicy" element={<ReturnPolicy/>} />
          <Route path="/privacyPolicy" element={<PrivacyPolicy/>} />
          <Route path="/Faqs" element={<Faqs/>} />
          <Route path="/forgot-password" element={<ForgotPassword/>} />
          <Route
            path="/homepage"
            element={
              <PrivateRoute>
                <HomePage />
              </PrivateRoute>
            }
          />
          <Route
            path="/UploadProduct"
            element={
              <PrivateRoute>
                <Uploadproduct/>
              </PrivateRoute>
            }
          />
          <Route
            path="/EditProduct/:productId"
            element={
              <PrivateRoute>
                <EditProduct/>
              </PrivateRoute>
            }
          />
          <Route
            path="/Base"
            element={
              <PrivateRoute>
                <Base/>
              </PrivateRoute>
            }
          />
          <Route
            path="/Profile"
            element={
              <PrivateRoute>
                <Profile/>
              </PrivateRoute>
            }
          />
          <Route
            path="/Templates"
            element={
              <PrivateRoute>
                <Templates/>
              </PrivateRoute>
            }
          />
          <Route
            path="/TemplateThemes"
            element={
              <PrivateRoute>
                <TemplateThemes/>
              </PrivateRoute>
            }
          />
          <Route
            path="/ManageAddress"
            element={
              <PrivateRoute>
                <ManageAddress/>
              </PrivateRoute>
            }
          />
          <Route
            path="/Contact"
            element={
              <PrivateRoute>
                <Contact/>
              </PrivateRoute>
            }
          />
          <Route
            path="/AboutMe"
            element={
              <PrivateRoute>
                <AboutMe/>
              </PrivateRoute>
            }
          />
          <Route
            path="/Orders"
            element={
              <PrivateRoute>
                <Orders/>
              </PrivateRoute>
            }
          />
          <Route
            path="/Proposals"
            element={
              <PrivateRoute>
                <Proposals/>
              </PrivateRoute>
            }
          />
          <Route
            path="/subscription"
            element={
              <PrivateRoute>
                <TemplateSelector />
              </PrivateRoute>
            }
          />
          <Route
            path="/AdminDashBoard"
            element={
              <PrivateRoute>
                <AdminDashBoard/>
              </PrivateRoute>
            }
          />
          <Route
            path="/vasstr-admin"
            element={
              <AdminRoute>
                <AdminDashboard/>
              </AdminRoute>
            }
          />
          <Route
            path="/designer-onboarding"
            element={
              <PrivateRoute>
                <DesignerOnboarding/>
              </PrivateRoute>
            }
          />
          <Route
            path="/admin-designers"
            element={
              <PrivateRoute>
                <AdminDesignerDashboard/>
              </PrivateRoute>
            }
          />
          <Route
            path="/designer-kyc"
            element={
              <PrivateRoute>
                <DesignerKYC/>
              </PrivateRoute>
            }
          />
          <Route
            path="/designer-profile"
            element={
              <PrivateRoute>
                <DesignerProfile/>
              </PrivateRoute>
            }
          />
          <Route path="/Register" element={<Register/>}/>

          <Route path="/template1" element={<Template1 />} />
          <Route path="/template2" element={<Template2 />} />
          <Route path="/template3" element={<Template3 />} />
          <Route path="/template4" element={<Template4 />} />
          <Route path="/template5" element={<Template5 />} />
          <Route path="/template6" element={<Template6 />} />
          <Route path="/template7" element={<Template7 />} />
          <Route path="/template8" element={<Template8 />} />
          <Route path="/template9" element={<Template9 />} />
          <Route path="/template10" element={<Template10 />} />
          <Route path="/template11" element={<Template11 />} />
          <Route path="/template12" element={<Template12 />} />
          <Route path="/template13" element={<Template13 />} />
          <Route path="/template14" element={<Template14 />} />
          <Route path="/template15" element={<Template15 />} />
          <Route path="/template16" element={<Template16 />} />
          <Route path="/template17" element={<Template17 />} />
          <Route path="/template18" element={<Template18 />} />
          <Route path="/template19" element={<Template19 />} />
          <Route path="/template20" element={<Template20 />} />
        </Routes>
      </AuthProvider>
    </Router>
  );
}

export default App;